const LoginBaseView = Backbone.View.extend({

  mailcheck() {
    const _this = this;

    // bind the mailcheck on on "blur"
    this.$inputText.on('blur', function () {
      $(this).mailcheck({
        suggested: _.bind(function (element, suggestion) {
          //  $suggestion = $("<p>"+window.lookup("Did you mean")+": <a href='javascript:void(0)'>"+suggestion.full+"</a>?</p>"),
          const $this = $(this);
          const $tooltip = $this.parent().find('.tooltip');

          // if tooltip exisits and message is equal to the last tooltip
          if ($tooltip.length > 0 && this.currentTooltipSuggestion == suggestion.full) return;

          // build tooltip
          $this.tooltip({
            html: true,
            title: `${window.lookup('Did you mean')}: <a href='javascript:void(0)'>${suggestion.full}</a>`,
            placement: 'bottom',
            trigger: 'manual',
          });

          $this.tooltip('show');

          $this.parent().find('.tooltip').css({ left: 'auto' }).attr({ tabindex: '-1' });

          // set the scoped tooltip and tooltip suggestion
          _this.currentTooltip = $this;
          _this.currentTooltipSuggestion = suggestion.full;

          // bind a click event to tooltip
          $this.parent().find('.tooltip a').click(_.bind(() => {
            $this.val(suggestion.full).trigger('change');
            $this.tooltip('destroy');
            _this.currentTooltip = null;
          }, this));

          $this.on('input', () => {
            $this.tooltip('destroy');
            _this.currentTooltip = null;
          });
        }, this),
        empty() {},
      });
    });
  },

});

export default LoginBaseView;
